// extracted by mini-css-extract-plugin
module.exports = {"question":"question_question__2xGxY","heading":"question_heading__2RcsB","questionText":"question_questionText__Izisi"};